import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DateTime, Interval } from "luxon";
import { useLanguage } from "lang/Translate";
import { formatMoney } from "common/format";
import axios from "axios";

import InfoFlyout from "components/common/InfoFlyout/InfoFlyout";

//api
import api from "api/api";

let _timeOuts = [];
const FuelPriceController = () => {
	const [price, setPrice] = useState("N / A");
	const [indicator, setIndicator] = useState(0);
	const [timeOuts, setTimeOuts] = useState([]);
	const selectedSupplierId = useSelector(state => state.groupInfo.fuelSupplier);
	const currentPrices = useSelector(state => state.fuelPrices);
	const dispatch = useDispatch();
	const currLanguage = useLanguage();

	const icon = (
		<i className="fas fa-gas-pump" title={currLanguage === "PL" ? "Obecna cena paliwa" : "Current fuel price"} />
	);

	const getFuelPrices = useCallback(async () => {
		//refresh code
		{
			const localTime = DateTime.local();
			const serverTime = localTime.setZone("Europe/Warsaw");
			let refreshTime;

			if (serverTime.hour < 10) {
				refreshTime = serverTime.set({ hour: 10, minute: 0, second: 0, millisecond: 0 });
			} else if (serverTime.hour >= 10 && serverTime.hour < 22) {
				refreshTime = serverTime.set({ hour: 22, minute: 0, second: 0, millisecond: 0 });
			} else {
				refreshTime = serverTime.set({ hour: 10, minute: 0, second: 0, millisecond: 0 });
				refreshTime = refreshTime.plus({ days: 1 });
			}

			const timeToRefresh =
				Interval.fromDateTimes(serverTime, refreshTime)
					.toDuration()
					.toMillis() + 10000;
			// console.log("Czas do odświeżenia cen paliwa: " + timeToRefresh + "ms");

			if (isNaN(timeToRefresh)) {
				console.error("Fatal error: expected number but got NaN");
				return;
			}

			setTimeOuts(prevVal => [
				...prevVal,
				window.setTimeout(async () => {
					console.info("Refreshing fuel prices...");
					const a = await getFuelPrices();
					console.log(a);
					document.dispatchEvent(new CustomEvent("fuelPriceRefresh"));
				}, timeToRefresh)
			]);
		}

		try {
			const { data } = await axios.get(`${api}/fuel/prices`);
			dispatch({ type: "FUEL_PRICES_SET", state: data });
			return data;
		} catch (err) {
			console.error(err);
		}
	}, [dispatch]);

	//! (DO NOT USE - FOR DEBUGGING PURPOSES ONLY)
	// force the prices to refresh
	// useEffect(() => {
	// 	(async () => {
	// 		const r = await fetch(setFuelPricesApi);
	// 		const t = await r.text();
	// 		console.log(t);
	// 	})();
	// });

	useEffect(() => {
		if (currentPrices.length <= 0) return;
		if (selectedSupplierId == null || selectedSupplierId === "null") {
			setPrice("N / A");
			setIndicator(0);
			return;
		}

		const currSupplierPrices = Object.values(currentPrices.find(v => +v.ID === +selectedSupplierId + 1).prices); // selectedSupplierId is 0 based, but the db is 1 based
		setPrice(formatMoney(currSupplierPrices[currSupplierPrices.length - 1]));
		setIndicator(
			currSupplierPrices[currSupplierPrices.length - 1] > currSupplierPrices[currSupplierPrices.length - 2] ? 1 : -1
		);
	}, [selectedSupplierId, currentPrices]);

	// get fuel prices on game init and 3 seconds later and set their refresh
	useEffect(() => {
		getFuelPrices();
	}, [getFuelPrices]);
	useEffect(() => setTimeOuts(prevVal => [...prevVal, window.setTimeout(getFuelPrices, 3000)]), [getFuelPrices]);

	// clear timeouts on logout (that is on component unmount)
	useEffect(() => {
		_timeOuts = timeOuts;
	}, [timeOuts]);
	useEffect(() => () => _timeOuts.forEach(timeOut => clearTimeout(timeOut)), []);
	window.getFuelPrices = getFuelPrices;

	return <InfoFlyout icon={icon} value={price} indicator={indicator} />;
};

export default FuelPriceController;
